<app-modal
  #deleteMessageModal
  [modalMessage]="app.text.message.deleteQuestion"
  [modalTitle]="app.text.message.modalTitle"
  (ok)="app.message.deleteMessage(message)"
></app-modal>

@if (showMessages) {
  <div class="note-item">
    <div class="note-item__card">
      @if (app.unlockedId === message._id) {
        <app-message
          class="note-item__editor"
          [id]="message._id"
        ></app-message>
      }
      @if (app.unlockedId !== message._id) {
        <div class="note-item__content">
          <div class="note-item__body-row">
            <div class="note-item__body">
              <app-field
                [field]="app.fieldId.message.message"
                [model]="app.message.createMessageModel(message)"
                [disabled]="true"
                [itemsInputValue]="true"
                [showLabel]="false"
              ></app-field>
            </div>
            @if (app.unlockedId === null) {
              <div class="note-item__actions">
                <app-unlock
                  [id]="message._id"
                  [permission]="app.message.hasEditPermission(message)"
                  [hasText]="false"
            (unlock)="
              app.message.model = app.message.getModelClean(message);
              app.message.showContent()
            "
                  [title]="app.text.message.editComment"
                  >
                </app-unlock>
                @if (app.message.hasEditPermission(message)) {
                  <button
                    class="note-item__action-btn"
                    type="button"
                    (click)="deleteMessageModal.open()"
                    [title]="app.text.message.delete"
                    >
                    <i class="fa fa-trash"></i>
                  </button>
                }
              </div>
            }
          </div>
          <div class="note-item__credits">
            <span class="note-item__credit">
              @if (message != null) {
                <app-credits
                  type="message"
                  [inputDoc]="message"
                  [isCreated]="true"
                ></app-credits>
              }
            </span>
            @if (hasEditedCredits()) {
              <span class="note-item__credit note-item__credit--edited">
                @if (message != null) {
                  <app-credits
                    type="message"
                    [inputDoc]="message"
                    [isEdited]="true"
                  ></app-credits>
                }
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
